import React from "react";
import { useTranslation } from "react-i18next";
import { IoMdTrendingDown, IoMdTrendingUp } from "react-icons/io";
import { numberShortFormat } from "utils/currencyFormatter";

const ImportExportCard = ({ response }) => {
  const { t } = useTranslation();
  const { totalImportVolume, totalExportVolume } = response;
  const setUpTrend = (amount) => {
    let a = amount ? amount * 100 : 0;
    return a + "%";
  };
  const calcImportVSexport = (imprtVolume, exportVolume) => {
    let result = 0;
    if (imprtVolume && exportVolume) {
      result = (imprtVolume / exportVolume) * 100 || 0;
    }
    return result.toFixed(2) + "%";
  };
  const data = [
    {
      title: t("Import") + " " + t("Volume"),
      metricType: "Volume",
      amount: numberShortFormat(totalImportVolume),
      change: response.trendImportVolume,
      changePercentage: setUpTrend(response.trendImportVolume),

      changeType: "negative",
    },
    {
      title: t("Export") + " " + t("Volume"),
      metricType: "Volume",
      amount: numberShortFormat(totalExportVolume),
      change: response.trendExpendVolume,
      changePercentage: setUpTrend(response.trendExpendVolume),

      changeType: "positive",
    },
    {
      title: t("Import") + " vs " + t("Export"),
      metricType: "Percentage",
      amount: calcImportVSexport(totalImportVolume, totalExportVolume),
      change: response.trendImport2Export,
      changePercentage: setUpTrend(response.trendImport2Export),
      changeType: "positive",
    },
  ];
  return (
    <>
      {data.map((d) => (
        <div className="dashboard-card dash-import-export-card">
          <section>
            <label className="dash-card-sec-title">
              {t(d.metricType || "")}
            </label>
            <div className="dash-card-title">{d.title}</div>
          </section>
          <section>
            <div className="dash-card-value-big-text mt-3">{d.amount}</div>
            <div
              className={
                "dash-card-trend " + (d.change <= 0 ? "negative" : "positive")
              }
            >
              {d.changePercentage}
              {d.change >= 0 ? <IoMdTrendingUp /> : <IoMdTrendingDown />}
            </div>
          </section>
        </div>
      ))}
    </>
  );
};

export default ImportExportCard;
